import React from 'react';
import { Checkbox } from 'semantic-ui-react';

import { isDetailIngredient } from 'Pages/manageproduction/helpers/productionRecord';

export const GridCheckboxCell = (props) => {
  const { isReadOnly, inputProps: { onChange, ...inputProps } = {} } = props;
  const isIngredient = isDetailIngredient(props);
  if (isIngredient) {
    return (
      <div className="grid-item">
        <Checkbox disabled />
      </div>
    );
  }

  return (
    <div className="grid-item">
      <Checkbox
        disabled={isReadOnly}
        {...inputProps}
        onChange={(e, data) => {
          e.target.name = data.name;
          e.target.value = data.checked;
          e.target.index = data['data-index'];
          if (onChange) {
            onChange(e);
          }
        }}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/GridCheckboxCell.js